import React from "react";
import Modal from "react-bootstrap/Modal";

export const ModalImage = ({ show, onHide, imageUrl, imageTitle = "Hình ảnh" }) => {

    return (
        <Modal 
            show={show} 
            onHide={onHide} 
            centered 
            backdrop="static" 
            className="modal-new modal fade text-left"
            size="lg" 
        >
            <Modal.Header>
                <h4 className="modal-title color7-bold">
                    <span className="btn-icon-right">
                        <i className="mdi mdi-image-outline" style={{fontSize: '22px', verticalAlign: 'middle'}}></i>
                    </span>
                    &nbsp;{imageTitle}
                </h4>
                <button type="button" className="close-popup-new" onClick={onHide}>
                    <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
                </button>
            </Modal.Header>
            <Modal.Body>
                <div className="form-body text-center" style={{ padding: '0 10px 10px 10px' }}>
                    <img 
                        src={imageUrl} 
                        alt={imageTitle}
                        style={{
                            maxWidth: '100%',      
                            maxHeight: '80vh',     
                            borderRadius: '4px', 
                            objectFit: 'contain'    
                        }}
                    />
                </div>
            </Modal.Body>
        </Modal>
    );
};